import { Modal } from 'reactstrap';

const getOriginalBodyPadding = () => {
  const style = window.getComputedStyle(document.body, null);
  return parseInt((style && style.getPropertyValue('padding-right')) || 0, 10);
};

const setScrollbarWidth = (padding) => {
  document.body.style.paddingRight = padding > 0 ? `${padding}px` : null;
};

const getScrollbarWidth = () => {
  const scrollDiv = document.createElement('div');
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
};
const conditionallyUpdateScrollbar = () => {
  const scrollbarWidth = getScrollbarWidth();
  const fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  const bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (document.body.clientWidth < window.innerWidth) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
};

// We're extending the reactstrap Modal component here so that we can append
// the modal to any element specified rather than just the body element.
class CenteredModal extends Modal {
  init() {
    try {
      this._triggeringElement = document.activeElement;
    } catch (err) {
      this._triggeringElement = null;
    }
    this._element = document.createElement('div');
    this._element.setAttribute('tabindex', '-1');
    this._element.style.position = 'relative';
    this._element.style.zIndex = this.props.zIndex;
    this._element.className = this.props.className;
    this._originalBodyPadding = getOriginalBodyPadding();

    conditionallyUpdateScrollbar();
    // Append the modal/drawer to the application root
    document.querySelector(this.props.parentselector).appendChild(this._element);

    if (Modal.openCount === 0) {
      document.body.className = [document.body.className, 'modal-open'].join(' ');
    }
    Modal.openCount += 1;
  }
  destroy() {
    if (this._element) {
      document.querySelector(this.props.parentselector).removeChild(this._element);
      this._element = null;
    }
    if (this._triggeringElement) {
      if (this._triggeringElement.focus) this._triggeringElement.focus();
      this._triggeringElement = null;
    }
    if (Modal.openCount <= 1) {
      const modalOpenClassName = 'modal-open';
      const modalOpenClassNameRegex = new RegExp(`(^| )${modalOpenClassName}( |$)`);
      document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
    }
    Modal.openCount -= 1;
    setScrollbarWidth(this._originalBodyPadding);
  }
}

export default CenteredModal;



// WEBPACK FOOTER //
// ./src/components/CenteredModal/CenteredModal.jsx